import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import styles from './AdminPage.module.css';
import AdminSidebar from '../../components/admin/AdminSidebar/AdminSidebar';
import { Toaster } from 'react-hot-toast';

const AdminPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    let password = window.password;
    if (!password) {
      window.password = prompt('enter Password');
      password = window.password;
    }

    if (password !== 'admin_123') {
      navigate('/');
    }
  }, []);
  return (
    <div className={styles.wrap}>
      {/* Ліворуч сайдбар (всередині нього aside зі sticky height:100vh) */}
      <AdminSidebar />

      {/* Праворуч контент */}
      <main className={styles.main}>
        <header className={styles.pageHeader}>
          <h1 className={styles.title}>Admin dashboard</h1>
        </header>

        <div className={styles.content}>
          {/* Тут рендеряться вкладені сторінки адмінки */}
          <Outlet />
        </div>
      </main>
      <Toaster />
    </div>
  );
};

export default AdminPage;
